import { h as __h } from "preact";
import html from "~/util/html.js";
import color from "~/style/colors.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Avatar.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Avatar.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {string} name
 * @property {number | undefined} [size]
 */

const segmenter = new Intl.Segmenter(undefined, {
  granularity: "word"
});

/** @param {Props} props */
export default function Avatar(props) {
  const name = props.name ?? "";
  const size = props.size ?? 24;
  const initials = Array.from(segmenter.segment(name.replace(/[^\p{L}\p{N}\s]/gu, " "))).map(part => part.segment[0]?.trim().toLocaleUpperCase()).filter(Boolean).join("");
  return __h("svg", {
    "class": css.avatar,
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    style: "--background: " + color(name)
  }, __h("circle", {
    fill: "var(--background)",
    cx: "8",
    cy: "8",
    r: "8"
  }), __h("text", {
    "class": css.text,
    x: "8",
    y: "8.7",
    fill: "white",
    "text-anchor": "middle",
    "dominant-baseline": "middle",
    "font-size": "0.43rem",
    "font-weight": "900"
  }, initials));
}